import "./singleCustomerStories.scss";
import "../../src-utilities/header";
import "../../src-utilities/footer";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";
import JustValidate from "just-validate";

gsap.registerPlugin(ScrollTrigger);

//JS for hiding content below challenges
document.addEventListener("DOMContentLoaded", function () {
  // Select all the headings (adjust the selector as needed)
  var headings = document.querySelectorAll(".details h2");

  if (headings.length > 2) {
    var thirdHeading = headings[3];
    var sibling = thirdHeading;

    if (thirdHeading) {
      thirdHeading.style.display = "none";
    }

    if (sibling) {
      while ((sibling = sibling.nextElementSibling)) {
        sibling.style.display = "none";
      }
    }
  }
});

const validate = new JustValidate("#successform");

validate
  .addField("#success-fullname", [
    {
      rule: "required",
    },
    {
      rule: "minLength",
      value: 2,
    },
    {
      rule: "customRegexp",
      value: /^[a-zA-Z]+ [a-zA-Z]+$/,
    },
  ])
  .addField("#success-companyemail", [
    {
      rule: "required",
    },
    {
      rule: "email",
    },
    {
      validator: (value) => {
        let emailRegex =
          /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
        return emailRegex.test(value);
      },
      errorMessage: "Please Enter Valid Email Address",
    },
  ]);

let GoogleSendURL =
  "https://script.google.com/macros/s/AKfycbyML8OHUDSwwvY_QcBlZ2uHYN_rQIx_VlWZPLjpxoJ9dB8GQEr6J7U0D8kNzC3-p0nH/exec";

let loader = document.querySelector(".loader");

document
  .querySelector("#successform")
  .addEventListener("submit", async (event) => {
    event.preventDefault();
    if (validate.isValid === false) {
      return false;
    }

    loader.classList.add("active");

    let formData = new FormData(event.target);
    let fullName = formData.get("lfirstname").split(" ");
    let firstName, lastName;
    [firstName, ...lastName] = fullName;
    lastName = lastName.join(" ");
    let customer_story_name = formData.get("customer_story_name");
    let customer_story_url = formData.get("customer_story_url");
    formData.set("lfirstname", firstName);
    formData.set("llastname", lastName);
    formData.append("sendurlvalue", window.location.href);
    formData.append("lsource", "ChargeOn-CSS");
    formData.append("customer_story_url", customer_story_url);
    formData.append("customer_story_name", customer_story_name);

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    // Initiate the Sales IQ visitor data
    if (window.$zoho && window.$zoho.salesiq) {
      try {
        $zoho.salesiq.visitor.uniqueid();
        $zoho.salesiq.visitor.name(firstName + " " + lastName);
        $zoho.salesiq.visitor.email(formData.get("lemail"));
        console.log("SalesIQ Name/Email set");
      } catch (error) {
        console.warn("SalesIQ Error:", error);
      }
    }

    let raw = JSON.stringify({
      firstName: formData.get("lfirstname"),
      lastName: formData.get("llastname"),
      email: formData.get("lemail"),
      leadSource: formData.get("lsource"),
      websiteVisitURL: window.location.href,
      primaryCaseStudyName: formData.get("customer_story_name"),
      primaryCaseStudyLink: formData.get("customer_story_url"),
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    let googleRequestOptions = {
      method: "GET",
      redirect: "follow",
    };
    let request = "?";
    [...formData].forEach(([key, value], index) => {
      request += `${index === 0 ? "" : "&"}${key + "=" + value}`;
    });

    // Request 1: Main Backend
    const backendRequest = fetch(
      "https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp",
      requestOptions,
    );

    // Request 2: Update the Google Sheet Data
    const googleRequest = fetch(GoogleSendURL + request, googleRequestOptions);

    // Waiting until these request get's completed
    try {
      await Promise.allSettled([backendRequest, googleRequest]);
    } catch (e) {
      console.error("API Error", e);
    }

    // Redirect
    window.location.href =
      "https://products.cyntexa.com/success?download-succes-story";
  });

//#endregion Success Form
